import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import PasswordPolicy from "./passwordPolicy";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress } from "./redux/selectors";
const canEdit = security.isAllowed([Permissions.PasswordPolicyEdit]);
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    data: getData(state),
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getPasswordPolicy()),
    onSave: (changes) => dispatch(actionCreators.savePasswordPolicy(changes))
});
export default connect(mapStateToProps, mapDispatchToProps)(PasswordPolicy);
